import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'showdash',
})
export class ShowdashPipe extends DecimalPipe {
  transform(value: number): any {
    if (isNaN(value) === false && value !== 0) {
      return `${super.transform(value)}%`;
    }
    return '-';
  }
}



// WEBPACK FOOTER //
// ./src/app/showdash.pipe.ts